import * as Yup from "yup";
import { ContractTerm } from "../../types";

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Yup.InferType<typeof schema>;

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["FR"]).required("Required"),
  contractTerm: Yup.string()
    .oneOf(Object.values(ContractTerm))
    .required("Required"),
});

const CONFIG: ConfigType = {
  component: <></>,
  schema: schema,
  initialValues: {
    workCountry: "FR",
    contractTerm: ContractTerm.Fixed,
  },
  keysToExclude: [],
};

export default CONFIG;
